import axios from 'axios';
import { SendMail } from 'models/request';
import { trackPromise } from 'react-promise-tracker';

import { MAILSERVICE } from '../utils/constants';

/**
 * Send Mail
 * @param {Object} body
 * @param {string | number} body.protocols
 * @param {number} body.idUser
 * @param {number} body.idProgram
 * @param {string} body.to
 * @param {string} body.cc
 * @param {string} body.bcc
 * @param {string} body.subject
 * @param {string} body.body
 * @return {Promise<AxiosResponse>}
 */
const sendMail = (body: SendMail) => trackPromise(axios.post(`${MAILSERVICE}/sendDocumentMail`, body), 'modal');

/**
 * Send Archived Mail
 * @param {Object} body
 * @param {string | number} body.protocols
 * @param {number} body.idUser
 * @param {number} body.idProgram
 * @param {string} body.to
 * @param {string} body.cc
 * @param {string} body.bcc
 * @param {string} body.subject
 * @param {string} body.body
 * @return {Promise<AxiosResponse>}
 */
const sendArchivedMail = (body: SendMail) =>
  trackPromise(axios.post(`${MAILSERVICE}/sendArchiveDocumentMail`, body), 'modal');

export default {
  sendMail,
  sendArchivedMail,
};
